var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content"},[(!_vm.pollSelectedProjects || _vm.pollSelectedProjects.length === 0)?_c('LoadingIcon'):(_vm.pollSelectedProjects.length > 0)?_c(_vm.table,{tag:"v-component",attrs:{"type":_vm.pollType,"projects":_vm.selectedProjects,"tags":_vm.projectTags}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8b4fb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/poll/manage/Project.vue
// module id = null
// module chunks = 